import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../component/form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddUpdateMerchantType = ({
  onSubmit = () => { },
  onClose = () => { },
  onError = () => { },
  merchantTypeData = {},
  Style,
}) => {

  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  useEffect(() => {
    console.log("Merchant Type merchantTypeData", merchantTypeData);

    if (merchantTypeData?.id) {
      formik.setFieldValue("type_name", merchantTypeData?.type_name)
    }
  }, [])


  const validationSchema = yup.object({
    type_name: yup.string().required("This Field is Required"),
  });



  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      type_name: "",

    },
    validationSchema,
    onSubmit: async (values) => {


      const data = {
        type_name: values.type_name,
      };

      console.log("values", values);




      try {
        const url = merchantTypeData?.id ? `merchants/update-merchant-type/${merchantTypeData?.id}` : `merchants/add-merchant-type`;
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        if (onSubmit) onSubmit(apiRes?.message || "Merchant Type Added successfully");

        formik.resetForm();
        onClose();
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong"
        );
      }
    },
  });








  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>

        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>


            {/* type_name  */}

            <FeildWraper width="100%">
              <FormLabel required>Merchant Type</FormLabel>

              <input
                type="text"
                name="type_name"
                value={formik.values.type_name}
                onChange={formik.handleChange}
                placeholder="Type Name"
              />
              {formik.touched.type_name && formik.errors.type_name && (
                <FeildError>{formik.errors.type_name}</FeildError>
              )}
            </FeildWraper>


          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {merchantTypeData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdateMerchantType;
